<template>
  <a :href="linkHref">
    {{ title }}
  </a>
</template>

<script>
  export default {
    name: 'ReadMoreBtn',
    props: ['linkHref', 'title'],
  };
</script>

<style scoped lang="scss">
  @use '../AppVariables' as *;

  a {
    display: inline-block;
    padding: 20px 0px;
    border-bottom: 1px solid $fontColor;
    font-size: calc(0.8em + 0.2vw);
    cursor: pointer;
  }
</style>
